import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../constants/dropdown';

import {messageTextValidation, nameValidation, emailValidation, phoneValidation, locationValidation} from '../../../utils/itemValidation';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../common/inputs/RhinoSelect';

class Press extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    const firstEntry = [{display: 'Location*', 'value': ''}];
    const finalEntry = [{display: 'Virtual/Other', 'value': 'online@diamondsdirect.com'}];

    let newArray= firstEntry.concat(locations.locations).concat(finalEntry);

    this.state = {
      locations: newArray,

      inputName: '',
      inputEmail: '',
      inputPhone: '',
      inputLocation: '',
      inputMessage: '',

      errorName: null,
      errorEmail: null,
      errorPhone: null,
      errorLocation: null,
      errorMessage: null,

    };
	}

	componentWillMount() {
		document.title = 'Diamonds Direct - Contact Us';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	}

	componentDidMount() {

  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }


  changeName(evt) {
    this.setState({ inputName: evt.target.value }, () => {
      if(this.state.errorName && !nameValidation(this.state.inputName)) {
        this.setState({ errorName: null });
      }
    });
  }

  changeEmail(evt) {
    this.setState({ inputEmail: evt.target.value }, () => {
      if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
        this.setState({ errorEmail: null });
      }
    });
  }

  changePhone(evt) {
    this.setState({ inputPhone: evt.target.value }, () => {
      if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
        this.setState({ errorPhone: null });
      }
    });
  }

  changeLocation(evt) {
    this.setState({inputLocation: evt.target.value}, () => {
      if(this.state.errorLocation !== false && location !== '') {
        this.setState({errorLocation: null});
      }
    });
  }  

  changeMessage(evt) {
    this.setState({ inputMessage: evt.target.value }, () => {
      if(this.state.errorMessage && !messageTextValidation(this.state.inputMessage)) {
        this.setState({ errorMessage: null });
      }
    });
  }

  validateAll() {
    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let messageError = messageTextValidation(this.state.inputMessage);
    let locationError = locationValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null &&
       messageError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
      errorMessage: messageError
    });

    return !hasErrors;
  }

  submitContactRequest() {
    if(this.validateAll()) {

      let contactData = {
        full_name: this.state.inputName,
        email: this.state.inputEmail,
        phone: this.state.inputPhone,
        location: this.state.inputLocation,
        message: this.state.inputMessage,
      }

      this.props.commonPressRequest(contactData)
      .then(() => {
        // this.context.router.push('/thank-you');
        this.props.commonAlert('Thank you for submitting a inquiry! A member of our team will follow up with you shortly.', 'Continue Browsing', 'helping', '');
      });
      this.setState({
        inputName: '',
        inputEmail: '',
        inputPhone: '',
        inputLocation: '',
        inputMessage: '',
        errorName: null,
        errorEmail: null,
        errorPhone: null,
        errorLocation: null,
        errorMessage: null,
      });
      this.props.commonCloseContact();
    }
  }

	render() {
		return <div className='Press' ref={(div) => { this.parentForm = div; }}>
			<div className='scheduleHeader'>Press Inquiry</div>
			<div className='scheduleBody'>
        <div className='scheduleBr'></div>
        <div className={'sbText'}>Thank you for your interest in Diamonds Direct</div>
        <div className={'sbText'}>Please fill out the press inquiry form below and a member of our Public Relations team will be in touch ASAP</div>
        <div className='sbFormWrapper'>
  				<div className='contactPageForm'>
            <div className='formBody'>
              <div className='formRow'>
                
                <div className='oneHalfSection'>
                  <input 
                    className={this.state.errorName ? 'textInput error' : 'textInput'}
                    type='text' 
                    placeholder='Full Name&#42;'
                    value={this.state.inputName}
                    onChange={::this.changeName} />
                </div>
                <div className='oneHalfSection'>
                  <input 
                    className={this.state.errorEmail ? 'textInput error' : 'textInput'}
                    type='email' 
                    placeholder='Email Address&#42;'
                    value={this.state.inputEmail}
                    onChange={::this.changeEmail} />
                </div>
              </div>
              <div className='formRow'>
                <div className='oneHalfSection'>
                  <input 
                    className={this.state.errorPhone ? 'textInput error' : 'textInput'}
                    type='text' 
                    placeholder='Telephone'
                    value={this.state.inputPhone}
                    onChange={::this.changePhone} />
                </div>
                <div className='oneHalfSection'>
                  <input 
                    className={this.state.errorLocation ? 'textInput error' : 'textInput'}
                    type='text' 
                    placeholder='Media Outlet*'
                    value={this.state.inputLocation}
                    onChange={::this.changeLocation} />
                </div>
              </div>
              <div className='formRow'>
                <div className='textareaInputWrapper'>
                  <textarea
                    className={this.state.errorMessage ? 'textTextarea error' : 'textTextarea'}
                    placeholder='The detials of your inquiry, including deadline*'
                    value={this.state.inputMessage}
                    onChange={::this.changeMessage}>
                  </textarea>
                </div>
              </div>
              <div className='formRow'>
                <div className={'submitButton actionButton'} onClick={::this.submitContactRequest}>Submit</div>
              </div>
            </div>
          </div>
        </div>
			</div>
      <div className='scheduleFooterSpacer'></div>
		</div>;
	}
}
export default Press;

function mapStateToProps(state) {
  return {

  };
}

export const PressContainer = connect(
  mapStateToProps,
  allActionCreators
)(Press);


// WEBPACK FOOTER //
// ./src/components/views/contact/Press.jsx